(() => {
  const search = document.querySelector('.header--mobile .bs-mobile-search');
  if (!search || search.dataset.bsStickyReady) return;
  search.dataset.bsStickyReady = 'true';
  const mobile = window.matchMedia('(max-width: 991px)');
  const slot = document.createElement('div');
  slot.className = 'bs-mobile-search-slot';
  search.before(slot);
  slot.appendChild(search);
  let fixed = false;
  let pending = false;
  let naturalHeight = 0;
  const update = () => {
    pending = false;
    if (!mobile.matches) {
      search.classList.remove('is-stuck');
      slot.style.height = '';
      fixed = false;
      return;
    }
    if (!fixed) naturalHeight = search.getBoundingClientRect().height;
    const shouldFix = slot.getBoundingClientRect().top < 0;
    if (shouldFix !== fixed) {
      fixed = shouldFix;
      slot.style.height = fixed ? naturalHeight + 'px' : '';
      search.classList.toggle('is-stuck', fixed);
      window.dispatchEvent(new Event('resize'));
    }
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  update();
})();
